import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchServiceResignationModalInitialState: IHomeMatchState["serviceResignationModal"] = {
    isOpen: false
};
import {IHomeMatchState} from "../types/IHomeMatchState";

export const homeMatchServiceResignationModalInitialState: IHomeMatchState["serviceResignationModal"] = {
    isOpen: false
};
